import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { UserAuthContext } from '../context/AuthContext';
import LoadingModalPage from './LoadingModalPage';
import MessagesError from './MessagesError';

const Signup = () => {
  const [, setSavedForm] = useState(false);
  const [, setInfoSubmit] = useState(false);

  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [, setLoading] = useState(false);
  const [messageRecover, setMessageRecover] = useState(false);

  const { resetPassword } = UserAuthContext();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError('');
      setLoading(true);
      await resetPassword(email);
      setMessageRecover(true);
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <div className="relative flex flex-col justify-center min-h-screen overflow-hidden">
      {messageRecover && (
        <LoadingModalPage
          exitAfter={true}
          setInfoSubmit={setInfoSubmit}
          setSavedForm={setSavedForm}
          modal={true}
          title="Password Recover"
          textInside="Check your inbox for futher instructions."
        />
      )}
      {error && <MessagesError error={error} setError={setError} />}
      <div className="w-full px-6 m-auto rounded-md shadow-md lg:max-w-xl bg-gradient-to-bl from-blue-300 py-6">
        <p className="mt-0 text-xs font-light text-left text-gray-70">
          Do you already have account?{' '}
          <Link className="underline" to="/Signin">
            Sign in
          </Link>
        </p>
        <h3 className="text-2xl font-semibold text-center text-blue-900 pt-16 ">
          Forget Password?{' '}
        </h3>
        <form onSubmit={handleSubmit} className="mt-6">
          <div className="mb-2">
            <label
              htmlFor="email"
              className="block text-sm font-semibold text-gray-800"
            >
              Email
            </label>
            <input
              required
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              type="email"
              className="block w-full px-4 py-2 mt-2 text-blue-500  bg-white border rounded-md focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
          </div>

          <div className="mt-6">
            <button className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-blue-900 rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600">
              Reset Password{' '}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Signup;
